// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ExplanationGroup_loaderContainer__CAAXD"};